<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CompareListTableProductCell',
  props: ['product'],
  computed: {
    ...mapGetters({
      products: 'compare/products',
    }),
    productIdsWithoutCurrent() {
      return this.products
        .map((product) => product.id)
        .filter((productId) => productId !== this.product.id)
        .join(',');
    },
  },
};
</script>

<template>
  <div>
    {{ product.name }}

    <router-link
      :to="{ query: { productIds: productIdsWithoutCurrent } }"
      class="absolute top-2 right-2 rounded-md inline-flex text-gray-400 hover:text-gray-500
              focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
    >
      <i class="fas fa-times text-md"></i>
    </router-link>
  </div>
</template>
